import { useShallow } from 'zustand/react/shallow';

import {
  isPracticeLockEffectiveForState,
  practiceLockStore,
} from '../stores/practiceLockStore';
import { workStore } from '../stores/workStore';
import { hasExamWorkType } from '../types';

export const usePracticeLockStatus = (): boolean => {
  const { gracePeriodEndsAt, manualPracticeLocked } = practiceLockStore(
    useShallow(state => ({
      gracePeriodEndsAt: state.gracePeriodEndsAt,
      manualPracticeLocked: state.manualPracticeLocked,
    }))
  );
  const isExam = workStore(state => {
    return hasExamWorkType(state.currentWork);
  });

  return isPracticeLockEffectiveForState({
    gracePeriodEndsAt,
    isExam,
    manualPracticeLocked,
  });
};
